document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('click', function(event) {
  var mobileToggle = event.target.closest('[data-mobile-menu-toggle]');
  if (mobileToggle) {
    var panel = document.querySelector('[data-mobile-menu-panel]');
    if (panel) {
      var isOpen = panel.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  }

  var faqButton = event.target.closest('[data-faq-toggle]');
  if (faqButton) {
    var item = faqButton.closest('.ams-faq-item');
    if (item) item.classList.toggle('is-open');
  }
});
